module.exports = __webpack_public_path__ + "static/media/mgo1.f458c782.png";